import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { unsafeUrlDialogAtom } from '../atoms'

import { UnsafeUrlDialogAnnouncement } from './unsafe-url-dialog-announcement'

export const UnsafeUrlDialog: React.FC = () => {
  const { t } = useTranslation()
  const [unsafeUrl, setUnsafeUrl] = useAtom(unsafeUrlDialogAtom)
  const handleClose = () => setUnsafeUrl(undefined)

  return (
    <AnimatePresence>
      {unsafeUrl ? (
        <Root
          open
          onOpenChange={handleClose}
          describedBy={t('deep-link.unsafe-url-dialog.description')}
        >
          <UnsafeUrlDialogAnnouncement {...unsafeUrl} onClose={handleClose} />
        </Root>
      ) : undefined}
    </AnimatePresence>
  )
}

const Root = styled(Dialog)`
  background: var(--background-2);

  width: 400px;
  display: grid;
`
